import { Link, useLocation } from "react-router-dom";

import { FULL_MENU } from "../../constants/menu";

const MyBreadcrumb = () => {
  const location = useLocation();

  const activeMenu = FULL_MENU.find((c) => location.pathname.includes(c.to));
  const activeSubMenu = activeMenu?.items?.find((c) =>
    location.pathname.includes(c.to)
  );

  return (
    <>
      <div className="con_nav">
        <ul>
          <li className="home">
            <Link to="/">
              <img src="/assets/img/home.png" alt="" />
            </Link>
          </li>
          {activeMenu && (
            <li>
              <Link to={activeMenu.to}>{activeMenu?.title}</Link>
            </li>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M6.66659 3.3333L13.3333 9.99996L6.66659 16.6666"
              stroke="#999999"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {activeSubMenu && (
            <li>
              <span>{activeSubMenu?.title}</span>
            </li>
          )}
        </ul>
      </div>
      <div className="stitle">
        <h6>{activeMenu?.title}</h6>
        <h2>{activeSubMenu?.title}</h2>
      </div>
    </>
  );
};

export default MyBreadcrumb;
